import { lazy, Suspense, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { setConsentTracking } from "store/ConsentTracking/slice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { useRollbarPerson } from "@rollbar/react";
import { ModalManager } from "components/Modals/ModalManager";
import { NotificationContainer } from "components/notification/NotificationContainer";
import { useIdentifyTracking } from "hooks/useIdentifyTracking";
import useDisableTransitions from "hooks/useDisableTransitions";
import Loading from "components/loading/Loading";

const MicrositePage = lazy(() => import("./pages/MicrositePage"));
const EmbedPage = lazy(() => import("./pages/EmbedPage"));
const GatedContentProcessingPage = lazy(
    () => import("./pages/GatedContentProcessingPage")
);
const AuthorizePage = lazy(() => import("./pages/AuthorizePage"));

function App() {
    const location = useLocation();
    const doNotTrack = new URLSearchParams(location.search).get("doNotTrack");
    const dispatch = useDispatch();
    useIdentifyTracking();
    useDisableTransitions();

    const {
        globalNotifications: { notifications }
    } = useSelector((s: RootState) => s.notifications);

    const creator = useSelector((s: RootState) => s.playerCreator);
    useRollbarPerson({
        id: creator?.details?.userId,
        organizationId: creator?.details?.organizationId,
        stripeAccountId: creator?.details?.stripeAccountId
    });
    useEffect(() => {
        dispatch(setConsentTracking(!!doNotTrack));
    }, [dispatch, doNotTrack]);

    return (
        <>
            <NotificationContainer
                notifications={notifications}
                visible={false}
                shouldFade={false}
            />
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path="/" element={<MicrositePage />} />
                    <Route path="/:projectId" element={<MicrositePage />} />
                    <Route path="/watch" element={<MicrositePage />} />
                    <Route path="/embed" element={<EmbedPage />} />
                    <Route
                        path="/order-processing"
                        element={<GatedContentProcessingPage />}
                    />
                    <Route path="/authorize" element={<AuthorizePage />} />
                </Routes>
            </Suspense>
            <ModalManager />
        </>
    );
}

export default App;
